<div class="round-button flex flex-row justify-start items-center gap-x-1.5">
  <span class="round-button__circle-shape" [ngStyle]="{ background: color() }">
  </span>
  <span id="labelspan">{{ text() }}</span>
</div>
